import React from 'react'
import { css } from 'emotion'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { COLOR } from 'styles'

export default ({ selected }) =>
  selected ? (
    <FontAwesomeIcon icon="dot-circle" className={styles.selectedButton} />
  ) : (
    <FontAwesomeIcon icon="circle" className={styles.button} />
  )

const styles = {
  button: css({
    color: COLOR.black,
    fontSize: '3rem',
  }),
  selectedButton: css({
    color: COLOR.red,
    fontSize: '3rem',
  }),
}
